import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A roadside cable junction pillar: a slim grey enclosure on a short pedestal
// where underground feeders are jointed and tapped. A door, a vent slot and a
// cable duct entering the base.
const BODY = "#9aa0a6";
const BODY_DK = "#7c8288";
const BASE = "#6f6f74";
const DUCT = "#3a3a3e";

export const junctionBox = defineModel({
  id: "junction-box",
  batchId: "electric",
  name: "Junction box",
  tags: ["prop", "electric", "power", "grid", "distribution", "cable"],
  summary: "A cable junction pillar on a short pedestal.",
  footprint: 0.25,
  parts(): Part[] {
    return [
      // Pedestal and duct entry.
      { geometry: new THREE.BoxGeometry(0.3, 0.1, 0.24), color: BASE, position: [0, 0.05, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.06, 0.06), color: DUCT, position: [0, 0.04, 0.14] },
      // Enclosure.
      { geometry: new THREE.BoxGeometry(0.24, 0.46, 0.18), color: BODY, position: [0, 0.33, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.05, 0.2), color: BODY_DK, position: [0, 0.58, 0] },
      // Door with handle.
      { geometry: new THREE.BoxGeometry(0.18, 0.36, 0.02), color: BODY_DK, position: [0, 0.32, 0.095] },
      { geometry: new THREE.BoxGeometry(0.02, 0.06, 0.02), color: "#3a3a3e", position: [0.06, 0.32, 0.11] },
      // Vent slots near the top of the door.
      { geometry: new THREE.BoxGeometry(0.12, 0.015, 0.02), color: "#3a3a3e", position: [0, 0.46, 0.1] },
      { geometry: new THREE.BoxGeometry(0.12, 0.015, 0.02), color: "#3a3a3e", position: [0, 0.43, 0.1] },
    ];
  },
  animations: [],
});
